import { render, staticRenderFns } from "./Payments.vue?vue&type=template&id=4ef3cd1c&scoped=true&"
import script from "./Payments.vue?vue&type=script&lang=js&"
export * from "./Payments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef3cd1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ef3cd1c')) {
      api.createRecord('4ef3cd1c', component.options)
    } else {
      api.reload('4ef3cd1c', component.options)
    }
    module.hot.accept("./Payments.vue?vue&type=template&id=4ef3cd1c&scoped=true&", function () {
      api.rerender('4ef3cd1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/purchase/purchase-order/components/Payments.vue"
export default component.exports